var _style, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoStrokeGradient01(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 43.8 45",
    style: {
      enableBackground: "new 0 0 43.8 45"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:#FFFFFF;}\r\n\t.st2{display:none;fill:#FFFFFF;}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -0.0154603,
    y1: 1055.7283,
    x2: 43.922,
    y2: 1055.7283,
    gradientTransform: "matrix(1 0 0 1 0 -1033.2283)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D92588"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7630D9"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43.4,25.3c-0.3,0.6-0.9,1.2-1.7,1.8c-0.2,1-0.4,1.8-0.7,2.6c-0.4,1-0.9,1.8-1.4,2.4c1.9,1.6,2.3,3.1,2.3,4.2 c0,5.7-10.1,8.6-20,8.6s-20-3-20-8.6c0-1.1,0.4-2.7,2.3-4.2c-0.4-0.6-1-1.4-1.4-2.4c-0.3-0.8-0.5-1.7-0.7-2.6 c-0.8-0.5-1.3-1.1-1.7-1.8c-0.4-0.7-0.7-1.8-0.3-5.1c0.2-1.9,0.5-3.9,0.6-4.7C1,14,2.1,12.7,3.8,11.9C5.7,7.2,9,3.7,13.6,1.8 C17.3,0.1,20.8,0,21.8,0c0.1,0,0.2,0,0.2,0s0.1,0,0.2,0c1,0,4.4,0.1,8.2,1.8c4.6,2,7.9,5.5,9.8,10.2c1.7,0.8,2.8,2.1,3.1,3.6 c0.2,0.8,0.5,2.8,0.6,4.7C44.1,23.6,43.8,24.7,43.4,25.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10.1,26.8c-1.8-2.2-2.1-6-0.9-11.8c0.1-0.7,0.3-1.4,0.6-2.1c-1.1,1.5-1.9,3.4-2.4,5.5c-1,4.7-0.7,7.7,0.8,9.5 c2.1,2.5,6.8,3,13.9,3c3.1,0,5.8-0.1,8-0.4c-0.9,0-1.8,0-2.7,0C18.5,30.5,12.6,29.9,10.1,26.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25.7,12.9c0.7,0.2,1.3,0.7,1.4,1.4c0.1,0.5,0.3,0.8,0.4,0.8s0.3-0.3,0.4-0.8c0.2-0.7,0.7-1.3,1.4-1.4 c0.5-0.1,0.8-0.3,0.8-0.4c0-0.2-0.3-0.3-0.8-0.4c-0.7-0.2-1.3-0.7-1.4-1.4c-0.1-0.5-0.3-0.8-0.4-0.8s-0.3,0.3-0.4,0.8 c-0.2,0.7-0.7,1.3-1.4,1.4c-0.5,0.1-0.8,0.3-0.8,0.4C24.9,12.6,25.2,12.8,25.7,12.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32.5,14.3c-0.4-0.1-0.7-0.4-0.8-0.8c-0.1-0.3-0.1-0.4-0.2-0.4s-0.2,0.2-0.2,0.4c-0.1,0.4-0.4,0.7-0.8,0.8 c-0.3,0.1-0.4,0.1-0.4,0.2s0.2,0.2,0.4,0.2c0.4,0.1,0.7,0.4,0.8,0.8c0.1,0.3,0.1,0.4,0.2,0.4s0.2-0.2,0.2-0.4 c0.1-0.4,0.4-0.7,0.8-0.8c0.3-0.1,0.4-0.1,0.4-0.2S32.8,14.4,32.5,14.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M18.8,26.4c1.5,0,2.6-0.6,3.3-1.2l0,1h2.8v-5.6c0-3.5-2.4-5.9-6-5.9s-6,2.4-6,5.9 C12.8,24.2,15.1,26.4,18.8,26.4z M19,17.6c1.5,0,3,0.8,3,3.1c0,0.1,0,0.6,0,0.8c-0.2,1.3-1.5,2.3-3,2.3c-1.8,0-3-1.2-3-3.1 C15.9,18.8,17.1,17.6,19,17.6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M41.2,15.8c-0.3-1.4-1.9-2.2-2.7-2.4C34.4,1.5,22,2,22,2l0,0l0,0C22,2,9.5,1.5,5.4,13.4 c-0.7,0.2-2.4,0.9-2.7,2.4c-0.3,1.9-1.1,7.4-0.5,8.6c0.4,0.7,1.2,1.2,1.8,1.6c0.1,1.2,0.4,2.2,0.7,3.1c0.4,1,1,1.8,1.4,2.3 c0.1,0.1,0.4,0.6,0.3,1.2c-0.1,0.6-0.6,0.9-0.7,0.9c-1.1,0.9-1.8,1.8-1.8,2.9C3.9,40.1,12,43,22,43l0,0l0,0c10,0,18.1-3,18.1-6.6 c0-1-0.6-2-1.8-2.9c-0.1-0.1-0.5-0.4-0.7-0.9c-0.2-0.7,0.2-1.2,0.3-1.2c0.4-0.5,1-1.3,1.4-2.3c0.3-0.9,0.6-1.9,0.7-3.1 c0.6-0.3,1.4-0.9,1.8-1.6C42.4,23.2,41.5,17.7,41.2,15.8z M22,32.1L22,32.1L22,32.1c-12.7,0-18.3-1.5-15.8-13.9 C8.7,5.8,22,6.2,22,6.2l0,0l0,0c0,0,13.2-0.5,15.8,11.9C40.3,30.5,34.6,32.1,22,32.1z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoStrokeGradient01);
export default __webpack_public_path__ + "static/media/logo-stroke-gradient-01.c3ce431f40ce0c71a17e18ff8c5b09bb.svg";
export { ForwardRef as ReactComponent };